import { render } from "./Home.vue?vue&type=template&id=0bb80ee0&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=0bb80ee0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0bb80ee0"

export default script